import { monthCloseOutAlertConstants } from './constant';

const {
  GET_MONTH_CLOSE_OUT_ALERT_REQUEST,
  UPLOAD_MONTH_END_ALERT_SIGN_RESET,
  UPLOAD_MONTH_END_ALERT_SIGN_REQUEST,
  REOPEN_CLOSEOUT_REQUEST,
  REOPEN_CLOSEOUT_RESET,
  CREATE_CUSTOM_CLOSEOUT_REQUEST,
  CREATE_CUSTOM_CLOSEOUT_RESET,
  UPDATE_CUSTOM_CLOSEOUT_REQUEST,
  UPDATE_CUSTOM_CLOSEOUT_RESET,
  CANCEL_CUSTOM_CLOSEOUT_REQUEST,
  CANCEL_CUSTOM_CLOSEOUT_RESET,
} = monthCloseOutAlertConstants;

export const getMonthlyCloseOutAlert = (payload: any) => {
  return {
    type: GET_MONTH_CLOSE_OUT_ALERT_REQUEST,
    payload,
  };
};

export const uploadSignFileAction = (payload: any) => {
  return {
    type: UPLOAD_MONTH_END_ALERT_SIGN_REQUEST,
    payload,
  };
};

export const resetUploadSignFileAction = () => {
  return {
    type: UPLOAD_MONTH_END_ALERT_SIGN_RESET,
  };
};

export const reopenCloseoutAction = (payload: any) => {
  return {
    type: REOPEN_CLOSEOUT_REQUEST,
    payload,
  };
};

export const resetReopenCloseoutAction = () => {
  return {
    type: REOPEN_CLOSEOUT_RESET,
  };
};

//  BOPS-115 — custom closeout periods
export const createCustomCloseoutAction = (payload: any) => {
  return {
    type: CREATE_CUSTOM_CLOSEOUT_REQUEST,
    payload,
  };
};

export const resetCreateCustomCloseoutAction = () => {
  return {
    type: CREATE_CUSTOM_CLOSEOUT_RESET,
  };
};

export const updateCustomCloseoutAction = (payload: any) => {
  return {
    type: UPDATE_CUSTOM_CLOSEOUT_REQUEST,
    payload,
  };
};

export const resetUpdateCustomCloseoutAction = () => {
  return {
    type: UPDATE_CUSTOM_CLOSEOUT_RESET,
  };
};

export const cancelCustomCloseoutAction = (payload: any) => {
  return {
    type: CANCEL_CUSTOM_CLOSEOUT_REQUEST,
    payload,
  };
};

export const resetCancelCustomCloseoutAction = () => {
  return {
    type: CANCEL_CUSTOM_CLOSEOUT_RESET,
  };
};